<template>
  <div
    class="e-message-bar w-full font-light text-center text-sm text-black py-4.5 px-4 bg-golden-amber/30 border border-golden-amber rounded-2xl backdrop-blur-xs"
  >
    <slot></slot>
  </div>
</template>
